import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Select from "../select/Select";
import { checkParams } from "../../../src/util/Util";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";
import LoadingButtonText from "../loadingButtonText/loadingButtonText";

const AddNewClient = (props) => {
  const navigate = useNavigate();

  // const [clientDetails, setClientDetails] = useState([]);
  const [selectedTab, setSelectedTab] = useState("client_details");
  // eslint-disable-next-line
  const [organizationList, setOrganizationList] = useState([
    { key: 2, value: "AOC" },
    { key: 1, value: "SIC" },
    { key: "0", value: "PT Shop" },
  ]);
  // const [clientSettings, setClientSettings] = useState([]);
  const [organizationType, setOrganizationType] = useState(null);
  const [organizationTypeError, setOrganizationTypeError] = useState("");
  const [initOrganizationName, setInitOrganizationName] = useState("");
  const [practiceName, setPracticeName] = useState("");
  const [practiceNameError, setPracticeNameError] = useState("");
  const [rewardTypeError, setRewardTypeError] = useState("");
  const [firstName, setFirstName] = useState("");
  const [errorFirstName, setErrorFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errorLastName, setErrorLastName] = useState("");
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  // eslint-disable-next-line
  const [contentLoaded, setContentLoaded] = useState(true);
  // eslint-disable-next-line
  const [validToProceed, setValidToProceed] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [selectedOption] = useState([{ value: "Badges" }, { value: "Gift Card" }]);
  const [option, setOption] = useState("");
  const [giftValue, setGiftValue] = useState("");
  const [errorValue, setErrorValue] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // const userBusinessID =
  //   localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData"))
  //     ? JSON.parse(localStorage.getItem("userData")).business_id
  //     : -1;

  const { id } = useParams();

  const handleReward = (callVal, value) => {
    if (value === "") {
      setRewardTypeError("Please fill in Reward.");
    } else {
      setOption(value);
      setRewardTypeError("");
      setErrorValue("");
      setGiftValue("");
    }
  };

  const handleGiftValue = (value) => {
    value = value.replace(/\D/g, '');
    if (value.charAt(0) === '0') {
      value = value.replace('0', '');
    }

    if (value === "" || parseInt(value) === 0) {
      setErrorValue("Please fill in Reward value.");
      setGiftValue(value);
    } else if (parseInt(value) < 0) {
      setErrorValue("Reward value cannot be negative.");
    } else {
      setGiftValue(value);
      setErrorValue("");
    }
  };

  useEffect(() => {
    props.actSidebar(false);
    setShowLoader(true);
    if (id > 0) {
      var userData = JSON.parse(localStorage.getItem("userData"));
      if (userData === null) {
        props.checkLoggedIn(false);
      } else {
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
          .post(window.ajaxLink + "cloud_programs/get-client-info", { id })
          .then((res) => {
            if (res.data.responseData) {
              setShowLoader(false);
              var memberInfo = res.data.responseData;
              handleInitOrganizationType(memberInfo.company_type);
              setOrganizationType(memberInfo.company_type);
              setPracticeName(memberInfo.company_name);
              setFirstName(memberInfo.first_name);
              setLastName(memberInfo.last_name);
              setEmail(memberInfo.email);
              setOption(memberInfo.reward_type === "badge" ? "Badges" : "Gift Card");
              setGiftValue(memberInfo.value);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
    // eslint-disable-next-line
  }, [id]);

  const handlePracticeName = (val) => {
    setPracticeName(val);
    if (!checkParams(val.trim(), "address")) {
      setPracticeNameError("Please enter a valid Company/Practice Name.");
    } else if (val.length > 20) {
      setPracticeNameError("Maximal numbers of letters is 20.");
    } else {
      setPracticeNameError("");
    }
  };

  const handleInitOrganizationType = (type) => {
    setOrganizationType(type);
    const orgName = organizationList.find((org) => org.key === type);
    setInitOrganizationName(orgName.value);
  };

  const handleFirstName = (val) => {
    val = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    setFirstName(val);
    if (!checkParams(val.trim(), "firstname")) {
      setErrorFirstName("Please enter a valid first name.");
      setValidToProceed(false);
    } else if (val.length > 15) {
      setErrorFirstName("Maximal numbers of letters is 15.");
    } else {
      setErrorFirstName("");
    }
  };

  const handleLastName = (val) => {
    val = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    setLastName(val);
    if (!checkParams(val.trim(), "lastname")) {
      setErrorLastName("Please enter a valid last name.");
      setValidToProceed(false);
    } else if (val.length > 15) {
      setErrorLastName("Maximal numbers of letters is 15.");
    } else {
      setErrorLastName("");
    }
  };

  const handleOrganizationType = (callVal, value) => {
    if (callVal && value) {
      value = parseInt(value);
      callVal(value);
      let settingsObj = value;
      setOrganizationType(settingsObj);
    }
    if (callVal === null) {
      setOrganizationTypeError("Please fill in Organization Type.");
    } else {
      setOrganizationTypeError("");
    }
  };

  const handleEmail = (val) => {
    setEmail(val);
    if (!checkParams(val.trim(), "email") || val.trim().length > 50) {
      setErrorEmail("Please enter a valid email address.");
      setValidToProceed(false);
    } else {
      setErrorEmail("");
    }
  };

  const handleCancel = () => {
    navigate("/clients");
  };
  // eslint-disable-next-line
  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
    setContentLoaded(false);
  };

  const checkValidToProceed = () => {
    if (
      firstName.length > 1 &&
      errorFirstName.length === 0 &&
      lastName.length > 1 &&
      errorLastName.length === 0 &&
      email.length > 0 &&
      errorEmail.length === 0 &&
      organizationTypeError.length === 0 &&
      organizationType !== null &&
      practiceName.length > 0 &&
      practiceNameError.length === 0 &&
      option !== "" &&
      rewardTypeError.length === 0
    ) {
      handleSaveClient();
    } else {
      checkForValidation();
    }
  };

  const checkForValidation = () => {
    handleEmail(email);
    handleLastName(lastName);
    handleFirstName(firstName);
    handlePracticeName(practiceName);
    handleOrganizationType(organizationType);
    handleReward(null, option);
    if (option === "Gift Card") {
      handleGiftValue(giftValue);
    }
  };

  const handleSaveClient = () => {
    if (option === "Gift Card" && (giftValue === "" || parseInt(giftValue) === 0)) {
      setErrorValue("Please fill in Reward value.");
      return;
    }
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      if (id > 0) {
        setSubmitting(true);
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
          .post(window.ajaxLink + "cloud_therapist/save-new-client", {
            organizationType,
            practiceName,
            firstName,
            lastName,
            email: email.trim().toLowerCase(),
            editId: id,
            reward_type: option === "Gift Card" ? "gift" : "badge",
            value: giftValue,
          })
          .then((res) => {
            if (res.data.responseData) {
              localStorage.setItem("newClientEdited", "true");
              navigate("/clients");
            }
          })
          .catch((error) => {
            if (error.response.data.responseCode === 400) {
              setErrorEmail(error.response.data.errorData.emailErr);
            }
          }).finally(
            () => {
              setSubmitting(false);
            }
          );
      } else {
        setSubmitting(true);
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
          .post(window.ajaxLink + "cloud_therapist/save-new-client", {
            organizationType,
            practiceName,
            firstName,
            lastName,
            email: email.trim().toLowerCase(),
            reward_type: option === "Gift Card" ? "gift" : "badge",
            value: giftValue,
          })
          .then((res) => {
            if (res.data.responseData) {
              localStorage.setItem("newClientAdded", "true");
              navigate("/clients");
            }
          })
          .catch((error) => {
            if (error.response.data.responseCode === 400) {
              setErrorEmail(error.response.data.errorData.emailErr);
            }
          }).finally(
            () => {
              setSubmitting(false);
            }
          );;
      }
    }
  };
  return (
    <div className="patient_settings_container">
      <Breadcrumbs></Breadcrumbs>
      <div className="add_member_title_and_btn_holder">
        <div className="prog_det_title_hold">
          <div className="prog_det_title">{id ? "Edit Client" : "Add New Client"}</div>
        </div>
      </div>
      <div className="add_member_tab_container" style={{flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'stretch', gap: '15px', minHeight: '60px'}}>
        <div className="add_member_btn_holder" style={{display: 'flex', flexDirection: 'row', alignItems: 'stretch'}}>
          <div onClick={() => handleCancel()} className="cancel_btn_add_member" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            Cancel
          </div>
          <div onClick={() => {
            if(submitting){ return; }
            checkValidToProceed()
            }} className="save_btn_add_member" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <LoadingButtonText loading={submitting} text={"Save Client"} loadingText={"Saving Client"} />
          </div>
        </div>
      </div>
      {id > 0 && showLoader && (
        <div className="loader_full_container">
          <div className="p_load"></div>
        </div>
      )}
      <div className="add_member_hold" style={{ display: id > 0 && showLoader ? "none" : "block" }}>
        <div className="add_member_holder">
          <div className="input_wrapper" style={{margin: '0px auto', width: '100%'}}>
            {selectedTab === "client_details" && (
              <>
                <div className="add_member_patient_title">Client Details</div>

                <div>
                  <div style={{ marginTop: "0px", marginBottom: "10px" }} className="bottom_toggle_txt">
                    Organization Type
                  </div>
                  <div className={`relative_holder mg-5 ${id > 0 ? "" : "reg_select_wrapper"}`}>
                    <div style={{ marginBottom: "10px" }}>
                      <Select
                        placeholder={"Organization Type"}
                        selectOptions={organizationList}
                        initVal={initOrganizationName}
                        selectCallback={function (callVal, value) {
                          handleOrganizationType(callVal, value);
                        }}
                        callBackValue={setOrganizationType}
                        //selectError={!organizationType && organizationTypeError}
                        disabled={id > 0 ? true : false}
                      />
                    </div>
                  </div>
                  {organizationTypeError && <div className="email_error_msg">{organizationTypeError}</div>}
                </div>

                <div className="bottom_toggle_txt">Organization Name</div>
                <input
                  placeholder="Enter Company/Practice Name"
                  type="text"
                  value={practiceName}
                  className="patient_info_input"
                  // onChange={(e) => handleSettingsObj("first_name", e.currentTarget.value)}
                  onChange={(e) => handlePracticeName(e.currentTarget.value)}
                />
                {practiceNameError && <div className="email_error_msg">{practiceNameError}</div>}
                <div>
                  <div className="bottom_toggle_txt">Select Reward type</div>
                  <div className="relative_holder reg_select_wrapper mg-5">
                    <div>
                      <Select
                        placeholder={"Select Reward"}
                        selectOptions={selectedOption}
                        selectCallback={function (callVal, value) {
                          handleReward(callVal, value);
                        }}
                        callBackValue={setOption}
                        initVal={option}
                      />
                    </div>
                  </div>
                  {option === "Gift Card" && (
                    <div>
                      <div className="bottom_toggle_txt">Value</div>
                      <input
                        placeholder="Enter Gift Value"
                        type="text"
                        value={giftValue}
                        className="patient_info_input"
                        onChange={(e) => handleGiftValue(e.currentTarget.value)}
                        initVal={giftValue}
                        pattern="[1-9][0-9]*"
                      />
                      {errorValue && <div className="email_error_msg">{errorValue}</div>}
                    </div>
                  )}
                  {rewardTypeError && <div className="email_error_msg">{rewardTypeError}</div>}
                </div>
                <div className="divider-horizontal"></div>
                <div className="add_member_patient_title">Admin Details</div>
                <div className="bottom_toggle_txt">First Name</div>
                <input
                  placeholder="Enter First Name"
                  type="text"
                  value={firstName}
                  className="patient_info_input"
                  onChange={(e) => handleFirstName(e.currentTarget.value)}
                />
                {errorFirstName && <div className="email_error_msg">{errorFirstName}</div>}
                <div className="bottom_toggle_txt">Last Name</div>
                <input
                  placeholder="Enter Last Name"
                  type="text"
                  value={lastName}
                  className="patient_info_input"
                  onChange={(e) => handleLastName(e.currentTarget.value)}
                />
                {errorLastName && <div className="email_error_msg">{errorLastName}</div>}
                <div className="bottom_toggle_txt">Email</div>
                <input
                  placeholder="Enter Email"
                  type="text"
                  value={email}
                  className="patient_info_input"
                  onChange={(e) => handleEmail(e.currentTarget.value)}
                />
                {errorEmail && <div className="email_error_msg">{errorEmail}</div>}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewClient;
